export default values => ({
  rfc: values.rfc || ''
});
